import { IGenericBaryFormGroup } from '../GenericBaryFormGroup';
import { IFormBuilder } from '../IFormBuilder';
import { FormControl } from '@angular/forms';

import { AddressFormGroup } from '../AddressFormGroup';
import { BaryFormFactoryService } from '../../../services/bary-form-factory.service';
import { IAddress } from '../../address.model';
import { TransportMapper } from '../../../app/shared/mapper/transport-mapper';
import { BaryAddressUtil } from '../../../app/shared/util/bary-address-util';
import { BaryValidator } from '../../../validators/bary.validator';
import { Transport } from '../../transport.model';

interface IAddressFormBuilder extends IFormBuilder<AddressControls> {
  init(): IAddressFormBuilder;

  build(): IGenericBaryFormGroup<AddressControls>;
}

export type AddressControls = { [index: string]: any } & {
  autofill: FormControl;
  fullname: FormControl;
  streetNumber: FormControl;
  street: FormControl;
  city: FormControl;
  cityCode: FormControl;
  country: FormControl;
  zipCode: FormControl;
  floor: FormControl;
  additionals: FormControl;
};

export type AddressOption = {
  address?: IAddress;
  withoutValidators?: boolean;
  withoutFullname?: boolean;
};

export class AddressFormBuilder implements IAddressFormBuilder {
  private formName = 'addressForm';
  private controls?: AddressControls;
  private addressType = { pickup: false, delivery: false, address: false };

  constructor(private bcf: BaryFormFactoryService, protected baryAddressUtil: BaryAddressUtil) {}

  init(option?: AddressOption): AddressFormBuilder {
    this.addressType.address = true;
    return this.innerInit(option);
  }

  initFromTransport(transport?: Transport, isPickup = true): AddressFormBuilder {
    let address;
    if (transport) {
      if (isPickup) {
        address = TransportMapper.getPickupAddress(transport);
        this.addressType.pickup = true;
      } else {
        address = TransportMapper.getDeliveryAddress(transport);
        this.addressType.delivery = true;
      }
    }
    return this.innerInit({ address });
  }

  private innerInit(option?: AddressOption): AddressFormBuilder {
    this.controls = this.bcf.makeAddressWithOptionControls(option);
    return this;
  }

  build(): AddressFormGroup {
    return new AddressFormGroup(this.baryAddressUtil, this.formName, this.addressType, this.controls!, [
      BaryValidator.validateZipCodeAccordingCountryCode(this.controls!.zipCode, this.controls!.country),
    ]);
  }
}
